import { render } from "./CardPanel.vue?vue&type=template&id=399ce0fa&ts=true"
import script from "./CardPanel.vue?vue&type=script&lang=ts"
export * from "./CardPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__